// 画面の部品（JS のファイル）を読み込めなかったとき（更新・書き出し直しのあとなど）は、1回だけ自動で読み込み直す
const KEY = 'qs-chunk-reload-at';
const CHUNK_ERROR = /dynamically imported module|Importing a module script failed|Failed to fetch dynamically|error loading dynamically/i;

export function isChunkLoadError(err: unknown) {
  const message = err instanceof Error ? err.message : String(err);
  return CHUNK_ERROR.test(message);
}

/** 読み込み直したら true。30秒以内に2回目は読み込み直さない（直らないときに繰り返さない） */
export function reloadOnceOnChunkError(err: unknown): boolean {
  if (!isChunkLoadError(err)) return false;
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) ?? 0);
  } catch {
    // 保存できない環境でも読み込み直しは試す
  }
  if (Date.now() - last < 30_000) return false;
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // 同上
  }
  location.reload();
  return true;
}
